import { CardContent, Typography, styled } from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  mainBox: 'mainBox',
  titleMainBox: 'titleMainBox',
  svgIconsSize: 'svgIconsSize',
  ActionIcons: 'ActionIcons',
  subscriberOverviewAgGridStyle: 'subscriberOverviewAgGridStyle',
  addOrganizationsButton: 'addOrganizationsButton',
  cardComponent: 'cardComponent',
  errorCardComponent: 'errorCardComponent',
  cardHeader: 'cardHeader',
  cardContent: 'cardContent',
  closeAction: 'closeAction',
  subTitle: 'subTitle',
  emailTextFieldText: 'emailTextFieldText',
  textField: 'textField',
  formHelperText: 'formHelperText',
  addUserBtn: 'addUserBtn',
  loaderBox: 'loaderBox',
  mainGrid: 'mainGrid',
  innerGrid: 'innerGrid',
  logoBox: 'logoBox',
  formMainBox: 'formMainBox',
  formMainFormControl: 'formMainFormControl',
  formAllTextFields: 'formAllTextFields',
  eyeIconForPassword: 'eyeIconForPassword',
  submitButton: 'submitButton',
  deleteUserIcon: 'deleteUserIcon',
  activeChipColor: 'activeChipColor',
  inActiveChipColor: 'inActiveChipColor',
};

export const MainSectionCardContent = styled(CardContent)({
  height: '60%',
  overflow: 'auto',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: '#D9D9D9',
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#868686',
    borderRadius: '5px',
  },
  // [up('xs')]: {
  //   margin: '4px 0px 0px',
  // },
  // [up('sm')]: {
  //   margin: '4px 2px 0px',
  // },
  // [up('md')]: {
  //   margin: '5px 2px 0px',
  // },
  // [up('lg')]: {
  //   margin: '10px 5px 0px',
  // },
  // [up('xl')]: {
  //   margin: '13px 8px 0px',
  // },
  // [up('xxl')]: {
  //   margin: '18px 11px 0px',
  // },
});

export const RoleLabelTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.spacing(0.5),
  paddingTop: theme.spacing(1.5),
}));

export const SalesAdminLabelTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.spacing(0.5),
  paddingTop: theme.spacing(1.5),
}));

export const ExpireTimeLabelTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.spacing(0.5),
  marginTop: theme.spacing(1.5),
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.mainBox}`]: {
    height: `calc(100vh - ${theme.spacing(6)})`,
    [up('xs')]: {
      padding: '20px 14px',
    },
    [up('sm')]: {
      padding: '20px 16px',
    },
    [up('md')]: {
      padding: '23px 18px',
    },
    [up('lg')]: {
      padding: '25px 20px',
    },
    [up('xl')]: {
      padding: '30px 23px',
    },
    [up('xxl')]: {
      padding: '35px 25px',
    },
  },
  [`& .${classes.titleMainBox}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  [`& .${classes.ActionIcons}`]: {
    marginRight: '2vw',
    marginTop: '9px',
    cursor: 'pointer',
    [up('xs')]: {
      width: '12px',
      height: '12px',
    },
    [up('sm')]: {
      width: '14px',
      height: '14px',
    },
    [up('md')]: {
      width: '16px',
      height: '16px',
    },
    [up('lg')]: {
      width: '18px',
      height: '18px',
    },
    [up('xl')]: {
      width: '20px',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22px',
      height: '22px',
    },
  },
  [`& .${classes.subscriberOverviewAgGridStyle}`]: {
    [up('xs')]: {
      height: '60vh',
    },
    [up('sm')]: {
      height: '70vh',
    },
    [up('md')]: {
      height: '70vh',
    },
    [up('lg')]: {
      height: '72vh',
    },
    [up('xl')]: {
      height: '79vh',
    },
    [up('xxl')]: {
      height: '81vh',
    },
  },
  [`& .${classes.cardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
      // height: '340px',
    },
    [up('sm')]: {
      width: '410px',
      // height: '340px',
    },
    [up('md')]: {
      width: '425px',
      // height: '360px',
    },
    [up('lg')]: {
      width: '500px',
      // height: '410px',
    },
    [up('xl')]: {
      width: '530px',
      // height: '460px',
    },
    [up('xxl')]: {
      width: '650px',
      // height: '530px',
    },
  },
  [`& .${classes.errorCardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
      // height: '420px',
    },
    [up('sm')]: {
      width: '410px',
      // height: '410px',
    },
    [up('md')]: {
      width: '425px',
      // height: '430px',
    },
    [up('lg')]: {
      width: '500px',
      // height: '460px',
    },
    [up('xl')]: {
      width: '530px',
      // height: '510px',
    },
    [up('xxl')]: {
      width: '650px',
      // height: '590px',
    },
  },
  [`& .${classes.cardHeader}`]: {
    background: theme.palette.lunarBase.main,
    borderBottom: `1px solid ${theme.palette.lunarBase.lightest}`,
  },
  [`& .${classes.cardContent}`]: {
    height: '100%',
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
    [up('xs')]: {
      margin: '4px 0px 0px',
    },
    [up('sm')]: {
      margin: '4px 2px 0px',
    },
    [up('md')]: {
      margin: '5px 2px 0px',
    },
    [up('lg')]: {
      margin: '10px 5px 0px',
    },
    [up('xl')]: {
      margin: '13px 8px 0px',
    },
    [up('xxl')]: {
      margin: '18px 11px 0px',
    },
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.emailTextFieldText}`]: {
    fontWeight: 500,
    paddingBottom: theme.spacing(1.5),
  },
  [`& .${classes.textField}`]: {
    '& .MuiFormHelperText-root': {
      marginLeft: '0px',
    },
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '6px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '13px',
      },
      [up('lg')]: {
        height: '17px',
      },
      [up('xl')]: {
        height: '25px',
      },
      [up('xxl')]: {
        height: '34px',
      },
    },
  },
  [`& .${classes.formHelperText}`]: {
    // marginLeft: theme.spacing(1.5),
    color: '#d32f2f',
  },
  [`& .${classes.addUserBtn}`]: {
    ':hover': {
      background: theme.palette.primary.main,
      color: theme.palette.secondaryWhite.main,
    },
    [up('xs')]: {
      width: '70px',
      height: '25px',
      margin: '20px 0px 20px 16px',
    },
    [up('sm')]: {
      width: '74px',
      height: '24px',
      margin: '20px 0px 20px 16px',
    },
    [up('md')]: {
      width: '92px',
      height: '26px',
      margin: '20px 0px 20px 16px',
    },
    [up('lg')]: {
      width: '105px',
      height: '35px',
      margin: '20px 0px 20px 16px',
    },
    [up('xl')]: {
      width: '115px',
      height: '40px',
      margin: '20px 0px 20px 16px',
    },
    [up('xxl')]: {
      width: '133px',
      height: '52px',
      margin: '20px 0px 20px 16px',
    },
  },
  [`& .${classes.subTitle}`]: {
    padding: '0px 16px',
    color: theme.palette.shoeWax.dark,
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  [`& .${classes.mainGrid}`]: {
    height: '100vh',
    justifyContent: 'center',
    background: theme.palette.darkPurple.main,
  },

  [`& .${classes.innerGrid}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },

  [`& .${classes.logoBox}`]: {
    [up('xs')]: {
      width: '48px',
    },
    [up('sm')]: {
      width: '68px',
    },
    [up('md')]: {
      width: '88px',
    },
    [up('lg')]: {
      width: '108px',
    },
    [up('xl')]: {
      width: '128px',
    },
    [up('xxl')]: {
      width: '148px',
    },
  },

  [`& .${classes.formMainBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '75vh',
    width: '100%',
    overflow: 'auto',
    borderRadius: '10px',
    backgroundColor: theme.palette.secondaryWhite.main,
    boxShadow: `0px 2px 8px ${theme.palette.secondaryBlack.lighter}`,
    '&::-webkit-scrollbar': {
      width: '10px',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-track': {
      background: `${theme.palette.lynxWhite.main}`,
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: `${theme.palette.secondaryBlack.lighter}`,
      borderRadius: '5px',
    },
  },

  [`& .${classes.formMainFormControl}`]: {
    display: 'flex',
    flexDirection: 'column',
    width: '67.5%',
    padding: '8.5vh 0',
  },

  [`& .${classes.formAllTextFields}`]: {
    marginBottom: '30px',
    width: '100%',
  },

  [`& .${classes.eyeIconForPassword}`]: {
    filter: 'brightness(98%) contrast(60%) sepia(10%)',
    height: '20px',
    width: '20px',
  },

  [`& .${classes.submitButton}`]: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.darker,
    },
    [up('xs')]: {
      height: '44px',
    },
    [up('lg')]: {
      height: '50px',
    },
  },
  [`& .${classes.deleteUserIcon}`]: {
    fill: 'none',
    stroke: theme.palette.colorRed.main,
    cursor: 'pointer',
    [up('xs')]: {
      fontSize: '10px',
    },
    [up('sm')]: {
      fontSize: '10px',
    },
    [up('md')]: {
      fontSize: '12px',
    },
    [up('lg')]: {
      fontSize: '14px',
    },
    [up('xl')]: {
      fontSize: '16px',
    },
    [up('xxl')]: {
      fontSize: '18px',
    },
  },
  [`& .${classes.activeChipColor}`]: {
    background: theme.palette.colorGreen.main,
  },
  [`& .${classes.inActiveChipColor}`]: {
    background: theme.palette.colorRed.main,
  },
}));
